module.exports = __webpack_public_path__ + "img/2.585f813f.png";